<template>
  <div class="userpolicy">
    <div class="section">
      <div class="columns">
        <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
          <h1 class="subtitle">利用規約</h1>
          <p class="block">利用規約テキストが入ります。利用規約テキストが入ります。利用規約テキストが入ります。利用規約テキストが入ります。利用規約テキストが入ります。利用規約テキストが入ります。利用規約テキストが入ります。</p>
          <p class="block">利用規約テキストが入ります。利用規約テキストが入ります。利用規約テキストが入ります。利用規約テキストが入ります。利用規約テキストが入ります。利用規約テキストが入ります。利用規約テキストが入ります。</p>
        </div>
      </div>
    </div>

    <div class="section pt-2">
      <div class="columns">
        <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
          <h1 class="subtitle">プライバシーポリシー</h1>
          <p class="block">プライバシーポリシーテキストが入ります。プライバシーポリシーテキストが入ります。プライバシーポリシーテキストが入ります。プライバシーポリシーテキストが入ります。</p>
          <p class="block">プライバシーポリシーテキストが入ります。プライバシーポリシーテキストが入ります。プライバシーポリシーテキストが入ります。プライバシーポリシーテキストが入ります。</p>
          <div class="content">
            <ul>
              <li>リストリスト</li>
              <li>リストリスト</li>
              <li>リストリスト</li>
            </ul>
            <ol>
              <li>番号付きリストリスト</li>
              <li>番号付きリストリスト</li>
              <li>番号付きリストリスト</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserPolicy'
};
</script>

<style lang="scss" scoped>
  .userpolicy {
    font-size: $size-6-5;
  }
</style>
